import { Box, CleanButton, Heading, Icon, Flex } from '@gassan-ui'
import React, { FC } from 'react'
import { Link } from '@gassan-ui'

type Props = {
  onClickClose: () => void
  hasFilters: boolean
  onClickReset: () => void
}

const Header: FC<Props> = ({ onClickClose, children, hasFilters, onClickReset }) => {
  return (
    <Flex
      display={{ _: 'flex' }}
      justifyContent="space-between"
      alignItems="center"
      position="absolute"
      top={0}
      width="100%"
      height={['4rem', '4.5rem']}
      borderBottomWidth="1px"
      borderBottomStyle="solid"
      borderBottomColor="shades.200"
      zIndex={2}
      backgroundColor="#fff"
      px={{ _: '1rem', medium: '1.5rem' }}
    >
      <Box ml="-.75rem" minWidth={80}>
        <CleanButton onClick={onClickClose}>
          <Icon icon="cross" />
        </CleanButton>
      </Box>
      <Heading textAlign="center" variant="h3" mb={0}>
        {children}
      </Heading>
      <Box minWidth={80} display="flex" justifyContent="flex-end">
        {hasFilters && (
          <Link variant="blue" onClick={onClickReset}>
            Reset
          </Link>
        )}
      </Box>
    </Flex>
  )
}

export default Header
